import type { HealthRecordTypeType } from '@/types/domain/class/valueObjects/healthRecordType';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 健康記録種別
 */
export class HealthRecordType extends PrimitiveValueObject<HealthRecordTypeType> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: HealthRecordTypeType): HealthRecordType {
    return new HealthRecordType(value);
  }
}
